import { render, staticRenderFns } from "./HandleModal.vue?vue&type=template&id=8d992ada&scoped=true"
import script from "./HandleModal.vue?vue&type=script&lang=js"
export * from "./HandleModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d992ada",
  null
  
)

export default component.exports